<template>
  <div
      v-on:click.stop=""
      class="locale_dropdown">
    <div @click="langChangeButton()" class="locale_dropdown-active">
      <div class="locale_dropdown-active_item">
        <div v-html="getLangFlag(computedCurrentLocale.code)"></div>
        <span v-html="computedCurrentLocale.code"></span>
      </div>
      <svg width="11" height="6" viewBox="0 0 11 6" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5973 0.236437C10.4567 0.0958343 10.2659 0.0168481 10.0671 0.0168481C9.86818 0.0168481 9.67745 0.0958343 9.5368 0.236437L5.8243 3.94894L2.1118 0.236437C1.97035 0.0998192 1.7809 0.0242233 1.58425 0.0259323C1.38761 0.0276408 1.1995 0.106517 1.06044 0.245574C0.921383 0.384629 0.842506 0.572739 0.840798 0.769387C0.839089 0.966034 0.914686 1.15549 1.0513 1.29694L5.29405 5.53969C5.4347 5.68029 5.62543 5.75928 5.8243 5.75928C6.02318 5.75928 6.21391 5.68029 6.35455 5.53969L10.5973 1.29694C10.7379 1.15629 10.8169 0.965561 10.8169 0.766688C10.8169 0.567814 10.7379 0.377083 10.5973 0.236437Z"
            fill="#6366F1"/>
      </svg>
    </div>
<!--    <div class="media">-->
<!--      <img @click="langChangeButton()" src="img/lang.jpg" alt="" id="lang-img">-->
<!--      <i class="fa fa-circle color-theme-orange active"></i>-->
<!--    </div>-->
<!--    <div-->
<!--        v-on:click="() => {-->
<!--                $emit('update:value', !value)-->
<!--            }"-->
<!--        class="locale_dropdown-active">-->
<!--      <div class="locale_dropdown-active_item">-->
<!--        <div v-html="computedCurrentLocale.svg"></div>-->
<!--        <span v-html="computedCurrentLocale.shorthand"></span>-->
<!--      </div>-->
<!--      <svg width="11" height="6" viewBox="0 0 11 6" fill="none"-->
<!--           xmlns="http://www.w3.org/2000/svg">-->
<!--        <path-->
<!--            d="M10.5973 0.236437C10.4567 0.0958343 10.2659 0.0168481 10.0671 0.0168481C9.86818 0.0168481 9.67745 0.0958343 9.5368 0.236437L5.8243 3.94894L2.1118 0.236437C1.97035 0.0998192 1.7809 0.0242233 1.58425 0.0259323C1.38761 0.0276408 1.1995 0.106517 1.06044 0.245574C0.921383 0.384629 0.842506 0.572739 0.840798 0.769387C0.839089 0.966034 0.914686 1.15549 1.0513 1.29694L5.29405 5.53969C5.4347 5.68029 5.62543 5.75928 5.8243 5.75928C6.02318 5.75928 6.21391 5.68029 6.35455 5.53969L10.5973 1.29694C10.7379 1.15629 10.8169 0.965561 10.8169 0.766688C10.8169 0.567814 10.7379 0.377083 10.5973 0.236437Z"-->
<!--            fill="#6366F1"/>-->
<!--      </svg>-->
<!--    </div>-->
<!--    <ul-->
<!--        v-if="value">-->
<!--      <li-->
<!--          v-for="locale in availableLocales"-->
<!--          :key="locale.shorthand">-->
<!--        <a-->
<!--            v-on:click.prevent="handleSetLocale((locale.shorthand).toLowerCase())"-->
<!--            v-html="`${locale.svg} ${locale.title}`"-->
<!--            href="#">-->
<!--        </a>-->
<!--      </li>-->
<!--    </ul>-->
    <vue-bottom-sheet
        ref="myBottomSheet"
        max-height="90%"
    >
      <div class="padding-30">
        <h1>{{ $t('Language') }}</h1>
        <ul id="lang-list">
          <li @click="handleSetLocale(language.code)"
              v-for="language in this.$store.state.companyData.languages" :key="language.code">
            <p>{{ getLangFlag(language.code) }} {{ language.name }}</p>
          </li>
        </ul>
        <div style="height:200px"></div>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import {BASE_API_URL} from "@/appConstants";
import axios from "axios";
import router from "@/router/router";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";

export default {
  name: "VAppLocale",
  props: {
    value: {type: Boolean, required: false}
  },
  emits: ['update:value'],
  components: {
    VueBottomSheet
  },
  data() {
    return {

    }
  },
  computed: {
    computedCurrentLocale: function () {
      let locale = null,
          prefLangCode = this.$store.state.prefLangCode ? this.$store.state.prefLangCode : 'en';
      this.$store.state.companyData.languages.forEach((lang) => {
        if (lang.code === prefLangCode) {
          locale = lang;
          return;
        }
      });
      return locale
    },
  },
  mounted() {
    if(!this.$store.state.prefLangCode) {
      let browserLanguage = navigator.language || navigator.userLanguage;
      let languageCode = browserLanguage.substring(0, 2);


      this.$store.state.companyData.languages.forEach((lang) => {
        if (lang.code === languageCode) {
          this.handleSetLocale(languageCode);
          return;
        }
      });
    }

  },
  methods: {
    handleSetLocale(locale) {

      i18n.locale = locale;
      this.$store.commit('setPrefLangCode', locale);
      // this.$store.commit('setUserLocale', locale);

      this.updateServerTokenLanguage();
      this.reloadCompanyData();

      this.$emit('update:value', false)
      this.$refs.myBottomSheet.close();
    },
    reloadCompanyData() {
      var endpoint = BASE_API_URL +
          'locale?code=' + this.$store.state.companyName +
          '&identifier=' + this.$store.getters.getFingerprint +
          '&pref_lang_code=' + this.$store.state.prefLangCode;

      //add table id
      if (this.$store.state.tableId) endpoint += '&table_id=' + this.$store.state.tableId;

      axios.get(endpoint)
          .then(response => {
            this.companyData = response.data;
            this.$store.commit('saveCompanyData', this.companyData);
          })
          .catch(error => {
            router.push('error');
            console.log(error);
          })
    },
    updateServerTokenLanguage() {
      const endpoint = BASE_API_URL +
          'changelanguage?token=' + this.$store.state.companyData.token +
          '&lang_code=' + this.$store.state.prefLangCode;
      axios.get(endpoint)
          .then()
          .catch(error => {
            router.push('error');
            console.log(error);
          })
    },
    getLangFlag(code) {
      let langFlag = '🇬🇧';
      switch (code) {
        case 'en':
          return langFlag;
        case 'pl':
          return '🇵🇱';
        case 'de':
          return '🇩🇪';
        case 'ru':
          return '🇷🇺';
        case 'uk':
          return '🇺🇦';
        case 'ko':
          return '🇰🇷';
        case 'es':
          return '🇪🇸';
        case 'it':
          return '🇮🇹';
        case 'fr':
          return '🇫🇷';
        case 'tr':
          return '🇹🇷';
        case 'he':
          return '🇮🇱';
        case 'cs':
          return '🇨🇿';
        case 'lt':
          return '🇱🇹';

        default:
          return langFlag
      }
    },
    langChangeButton() {
      this.$refs.myBottomSheet.open();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.locale_dropdown {
  position: relative;

  &-active {
    cursor: default;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    border: 1px solid $color_blue_cornflower;
    border-radius: 6px;
    padding: 0 10px;

    &_item {
      display: flex;
      gap: 10px;
      align-items: center;
      text-transform: uppercase;

      & > div {
        font-size: 20px;
        height: auto;
      }

      span {
        width: 24px;
        font: {
          size: 16px;
        };
        color: $color_grey_oslo;
        margin: 0;
        line-height: inherit;
      }
    }
  }

  & > ul {
    padding: 18px 20px;
    position: absolute;
    z-index: 1002;
    background-color: $color_white;
    right: 0;
    border-radius: 20px 0;
    border: 1px solid $color_blue_cornflower;
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      a {
        height: 32px;
        flex-shrink: 0;
        display: flex;
        gap: 6px;
        align-items: center;
        font: {
          size: 16px;
        };
        color: $color_grey_oslo;
      }
    }
  }
}

#lang-img {
  border: 1px solid #fbf4fb;
  -webkit-box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
  -moz-box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
  box-shadow: 0px 0px 4px 1px rgba(66, 68, 90, 0.23);
  cursor: pointer;
}

#lang-list {
  list-style: none;
  padding: 0
}

.padding-30 {
  padding: 0 30px
}

#lang-list li {
  font-size: 30px;
  cursor: pointer;
  color: #1c1c1d;
  background-color: #f3f3f3;
  padding: 5px 10px;
  border-radius: 20px;
  margin: 0 0 9px 0;
}

#lang-list li p {
  padding: 0;
  line-height: 0;
}

.media img {
  height: 48px;
  width: 48px;
  border-radius: 12px;
}

.media .active {
  color: var(--f7-theme-color);
  font-size: 15px;
  border: 2px solid #fff;
  position: absolute;
  right: -8px;
  top: -7px;
  border-radius: 50%;
}

</style>
